import { useState } from 'react';
import IconDownload from '@picsart/icons/IconDownload';
import { ControlSizesLG, InlineButton } from '@picsart/inlineButton';
import { BottomSheet } from '@picsart/bottomsheet';
import { useTranslator } from '@picsart/rc/services/localization';

import DownloadImageMenu from '../DownloadImageMenu';

import useStyles from './styles';
import testIds from './testIds';

interface IExportProps {
  isDisabled: boolean;
}

const MobileExport = ({ isDisabled }: IExportProps) => {
  const classes = useStyles();
  const translate = useTranslator();
  const [downloadMenuIsOpen, setDownloadMenuIsOpen] = useState(false);

  return (
    <>
      <InlineButton
        data-testid={testIds.exportBtn}
        onClick={() => setDownloadMenuIsOpen(true)}
        size={ControlSizesLG}
        startIcon={IconDownload}
        isWithoutBorder
        isWithoutBackground
        isDisabled={isDisabled}
      />

      <BottomSheet
        className={classes.downloadBottomSheetIndex}
        isOpen={downloadMenuIsOpen}
        onClose={() => setDownloadMenuIsOpen(false)}
        title={translate('Download')}
        isFullWidth
        hideHeader
      >
        <DownloadImageMenu onClose={() => setDownloadMenuIsOpen(false)} showZipNameField={false} />
      </BottomSheet>
    </>
  );
};

export default MobileExport;
